<template>
  <div class="timeData">
    <!-- 地图 -->
    <myMap :Pzoom="4" :mapStyle="mapStyle" :center="center" @hideSit='showSit = false' :positions="points"
      @showInfo="showRight" :type="param" :showSit="showSit" @setCenter="setC"></myMap>
    <!-- 地图点位搜索-->
    <mapSearch ref="mapSearch" style="position:absolute;top: 0.32rem;left: 26px;zIndex:102;" :positions="positions"
      :sitChecked="checkedList" @showContent="showContent" @isShowRight="isShowRight"></mapSearch>
    <div class="selectSite" :style="{ left: moveBlock ? '332px' : '26px' }">
      <!-- 站点类型筛选-->
      <div class="selectBlock state-type flex-c">
        <p class="ellipsis" v-for="(type, index) in sitChecked" :key="index">
          <a-Checkbox :checked="type.checked" style="marginRight:0.1rem" @click="chooseType(type)"
            :disabled="type.name == '国控站' && $store.state.isCompare" />{{ type.name }}
        </p>
      </div>
      <!-- 参数类型筛选-->
      <div class="selectBlock params flex-c" v-show="params.length">
        <li v-for="(p, index) in params" @click="param = p" :class="{ chooseParam: p === param }" :key="index">{{ p }}
        </li>
      </div>
    </div>
    <!-- 右侧信息详情 -->
    <div class="sitInfo">
      <!-- 展开收起 -->
      <div class="togSitDetail" @click="showSit = !showSit" :class="{ reserve: showSit === false }" v-if="sitDetail">
        <i class="el-icon-right" style="fontSize:0.3rem;"></i>
      </div>
      <!-- 方向盘以及颜色指示图 -->
      <div class="paramRange">
        <img v-if="param == 'Noise'" src="@/assets/img/noiseStandards.png">
        <img v-else src="@/assets/img/rang.png">
      </div>
      <div class="wind">
        <img src="@/assets/img/windF.png" :style="{ transform: windD }">
      </div>
      <!-- 设备信息盒子-->
      <div class="sitDetail" v-show="showSit" v-if="sitDetail">
        <div class="sitDetail-header ellipsis">
          <div class="sitDetail-name flex-r" style="width:100%;">
            <h2>{{ sitDetail.name }}</h2>
            <span></span>
          </div>
          <div style="display:flex;justify-content:space-between;width:100%">
            <div>设备序列号：{{ sitDetail.dname }}</div>
            <div class="ellipsis" style="display:inline-block;width:2.5rem;">地址：{{ sitDetail.address }}</div>
          </div>
        </div>
        <!-- 报警信息 -->
        <div class="alarmMessage" v-if="sitDetail.isyujing == 1">
          <div>
            <i class="el-icon-warning" style="font-size:0.2rem"></i>
            <span style="padding-left:10px" class="ellipsis">警报：{{ sitDetail.trtitle }}</span>
          </div>
          <div class="el-icon-arrow-right" style="font-size:0.2rem;float:right;cursor:pointer"
            @click="$router.push({ path: '/triggerRecord' })"></div>
        </div>
        <!-- 控制设备空气参数值 -->
        <div class="showNum">
          <div class="flex-r" style="flexWrap:wrap;justifyContent:space-between;">
            <div class="flex-r" style="justifyContent:space-between;float:left">
              <h3>最新数据</h3>
              <span style="color:rgba(255,255,255,0.8);fontSize:14px;margin:0 8px;"> (更新于{{ updateTime }})</span>
            </div>
            <p style="float:left;textAlign:right;color:rgba(255,255,255,0.8);fontSize:12px;">
              {{ hasClickP }}浓度单位{{ chooseParamU }}</p>
          </div>
          <div class="showNum-info flex-r" style="justifyContent:space-between;">
            <!-- AQI待修改 -->
            <div v-show="sitDetail.AQI !== '0'" class="showNum-info-left flex-c ellipsis"
              style="height:1.28rem;padding:0 0.2rem;" :style="{ background: areaConfig('AQI', sitDetail.AQI).color }">
              <span>AQI</span>
              <p>{{ sitDetail.AQI }}</p>
              <span>{{ mainAQI.value > 100 ? '超标污染物' : '首要污染物' }}:{{ mainAQI.key }}</span>
            </div>
            <div class="showNum-info-right">
              <div v-for="(param, index) in sitParams" :key="index" v-show="param !== 'AQI' && param !== 'PM1'"
                @click="changeUnit(param)" :class="{ chooseP: param === hasClickP }">
                <span v-if="param" v-show="param !== 'AQI'">{{ param ? param : '' }}：{{ sitDetail[param] }}</span>
              </div>
            </div>
          </div>
        </div>
        <mapChart :params="sitParams" :code="sitDetail.code" v-if="sitDetail"></mapChart>
      </div>
    </div>
  </div>
</template>

<script>
import areaConfig from '@/common/js/range.js'
import getAqi from '@/common/js/aqi.js'
import { stringTime, parseTime } from '@/common/js/commont.js'
import MixinWL from '@/store/wl/mixinsWl.js'
import mapSearch from '@/components/timeData/mapSearch.vue'
import mapChart from '@/components/timeData/mapChart.vue'
import myMap from '@/components/timeData/myMap.vue'
import { message } from 'ant-design-vue'
import { requestData } from '@/common/js/commont.js'
export default {
  mixins: [MixinWL],
  components: {
    myMap,
    mapSearch,
    mapChart
  },
  data() {
    return {
      mapStyle: {
        styleJson: [
          {
            featureType: 'highway',
            elementType: 'all',
            stylers: {
              color: '#FFFFFF'
            }
          }
        ]
      },
      showSit: false, // 控制右侧设备详情信息的展示与隐藏
      allParams: [],  // 所有参数类型集合
      positions: [],  // 设备列表
      sitChecked: [],  // 站点类型
      checkedList: [], // 选中的站点
      windD: '',  //风向
      points: [],
      hasClickP: '',
      chooseParamU: '',
      comState: false,
      param: '',
      // 参数列表
      params: [],
      center: {
        lng: 119.4261,
        lat: 32.75
      },
      // 设备点位详情
      sitDetail: '',
      mainAQI: {
        key: '无',
        value: '0'
      },
      moveBlock: false
    }
  },
  created() {
    if (window.localStorage.getItem('center')) {
      this.center = JSON.parse(window.localStorage.getItem('center'))
    }
    this.getMapinfo()
    this.getWeather()
    this.getBigType()
    this.timerId2 = setInterval(() => {
      this.getWeather()
    }, 1000 * 60 * 60)
    // 判断是否整点
    this.timerId1 = setInterval(() => {
      if (parseTime()) {
        this.getMapinfo()
      }
    }, 1000)
    this.$once('hook:beforeDestroy', () => {
      clearInterval(this.timerId1)
      clearInterval(this.timerId2)
    })
  },
  methods: {
    changeUnit(param) {
      this.allParams.forEach(item => {
        if (this.sitDetail.type === item.type) {
          if (item.name === param) {
            this.hasClickP = param
            this.chooseParamU = item.GB
          }
        }
      })
    },
    getBigType() {
      var ts = stringTime(new Date())
      var data = {
        token: window.localStorage.getItem('token'),
        account: window.localStorage.getItem('account'),
        ts
      }
      this.getAllBig(data).then(res => {
        this.sitChecked = []
        res.forEach(item => {
          var params = item.params
          var y = {
            checked: item.bigtype == '国控站' ? false : true,
            name: item.bigtype,
            params,
            type: item.type
          }
          this.sitChecked.push(y)
          this.checkedList = []
          this.sitChecked.forEach(item => {
            if (item.checked) {
              this.checkedList.push(item)
              this.$refs.mapSearch.searching = true
              // 参数交集
              item.params.forEach(p => {
                if (this.params.indexOf(p) === -1) {
                  this.params.push(p)
                }
              })
            }
          })
          this.params.forEach((p, index) => {
            // 参数AQI始终在第一位
            if (p === 'AQI') {
              this.params.splice(index, 1)
              this.params.unshift(p)
            }
          })
        })
      })
    },
    // 设置中心
    setC(center) {
      this.center = center
    },
    // 获取风向
    getWeather() {
      this.$axios.post('https://www.airdaas.com/api/city/getWeather', requestData({ city: '静安区' })).then(data => {
        let info = JSON.parse(data.data.data[0].value)
        if (info) {
          if (info.windDir === '北风') {
            this.windD = 'rotate(0deg)'
          } else if (info.windDir === '东北风') {
            this.windD = 'rotate(45deg)'
          } else if (info.windDir === '东风') {
            this.windD = 'rotate(90deg)'
          } else if (info.windDir === '东南风') {
            this.windD = 'rotate(135deg)'
          } else if (info.windDir === '南风') {
            this.windD = 'rotate(180deg)'
          } else if (info.windDir === '西南风') {
            this.windD = 'rotate(225deg)'
          } else if (info.windDir === '西风') {
            this.windD = 'rotate(270deg)'
          } else if (info.windDir === '西北风') {
            this.windD = 'rotate(315deg)'
          }
        }
      })
    },
    areaConfig(type, num) {
      return areaConfig(type, num)
    },
    // 显示控制右边信息
    showRight(data) {
      if (data) {
        this.showSit = true
      } else {
        this.showSit = false
      }
      this.sitDetail = data
    },
    // 获取设备点位接口(一小时一次)
    getMapinfo() {
      var hide = message.loading('获取点位中..', 0)
      var ts = stringTime(new Date())
      var data = {
        token: window.localStorage.getItem('token'),
        account: window.localStorage.getItem('account'),
        ts
      }
      this.getMapInfo(data).then((res) => {
        this.allParams = res.paramslist
      }).catch(e => {
        this.$message.warning(e.message)
      }).finally(hide)
    },
    // 选择设备 这里逻辑是设备的交集 参数的交集
    chooseType(type) {
      this.checkedList = this.sitChecked
      type.checked = !type.checked
      this.params = []
      this.points = []
      if (this.positions) {
        this.sitChecked.forEach(item => {
          if (item.checked) {
            // 参数交集
            item.params.forEach(p => {
              if (this.params.indexOf(p) === -1) {
                this.params.push(p)
              }
            })
            this.positions.forEach(it => {
              item.type.forEach(type => {
                if (parseInt(it.type) === type) {
                  this.points.push(it)
                }
              })
            })
          } else {
            item.arr = []
          }
        })
      }
      // 将aqi放在最前面
      this.params.forEach((p, index) => {
        if (p === 'AQI') {
          this.params.splice(index, 1)
          this.params.unshift(p)
        }
      })
      this.$refs.mapSearch.searching = this.points.length == 0 ? false : true
    },
    // 返回是否展示设备列表
    showContent(val) {
      this.moveBlock = val
    },
    isShowRight(val) {
      this.showSit = val
    }
  },
  watch: {
    sitDetail(value) {
      this.$nextTick(() => {
        this.mainAQI.value = getAqi(value).value
        if (getAqi(value).value >= 50) {
          this.mainAQI.key = getAqi(value).key
        } else {
          this.mainAQI.key = '无'
        }
      })
    },
    MapInfoWL(value) {
      this.$nextTick(() => {
        this.positions = value.list
        // 已选中站点下的设备
        this.sitChecked.forEach(i => {
          if (i.checked) {
            this.positions.forEach(j => {
              i.type.forEach(t => {
                if (parseInt(j.type) === t) {
                  this.points.push(j)
                }
              })
            })
          }
        })
      })
    },
    params(v) {
      let includePM = v.some(i => i == 'PM2.5')
      if (includePM) {
        this.param = 'PM2.5'
        this.hasClickP = 'PM2.5'
      } else {
        this.param = v[0]
        this.hasClickP = v[0]
      }
    },
    showSit(v) {
      if (v) {
        this.changeUnit(this.param)
      }
    }
  },
  computed: {
    updateTime() {
      return stringTime(new Date(parseInt(this.sitDetail.create_time + '000')))
    },
    sitParams() {
      var arr = []
      if (this.sitDetail && this.params.length) {
        this.params.forEach(param => {
          if (this.sitDetail[param]) {
            arr.push(param)
          }
        })
      }
      return arr
    }
  }
}
</script>

<style lang="less" scoped>
.timeData {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;

  .selectSite {
    position: absolute;
    top: 80px;
    z-index: 104;

    .selectBlock {
      padding: 0.12rem;
      width: 120px;
      border-radius: 0.06rem;
      background: #405891;
      color: #fff;
      justify-content: space-between;
    }

    .state-type {
      p {
        margin: 0;
        padding: 0;
        width: 100%;
        text-align: left;

        input {
          width: 0.2rem;
        }
      }
    }

    .params {
      min-height: 1.5rem;
      max-height: 5rem;
      overflow: auto;
      margin-top: 0.2rem;

      li {
        height: 0.34rem;
        width: 100px;
        border-radius: 0.06rem;
        text-align: left;
        padding: 0 0.2rem;
        line-height: 0.34rem;
        cursor: pointer;
      }

      .chooseParam {
        background: #437ede;
      }
    }
  }

  .sitInfo {
    color: white;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: flex-end;
    overflow: block;

    .togSitDetail {
      width: 0.6rem;
      height: 0.6rem;
      position: absolute;
      top: 50%;
      color: white;
      left: -0.8rem;
      background: rgba(0, 0, 0, 0.12);
      border: 1px solid rgba(0, 0, 0, 0.15);
      transform: tranlateY(-50%);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .togSitDetail:hover {
      color: red;
    }

    .reserve {
      transform: rotate(-180deg);
    }

    .sitDetail {
      position: relative;
      background: #405891;
      width: 5.86rem;
      height: 100%;
      overflow-y: auto;

      .sitDetail-header {
        width: 100%;
        height: 1.02rem;
        padding: 0.2rem;
        background: #437ede;

        .sitDetail-name {
          h2 {
            color: white;
            font-size: 0.18rem;
          }

          span {
            font-size: 0.12rem;
          }

          justify-content: space-between;
        }
      }

      .alarmMessage {
        width: 5rem;
        height: 0.4rem;
        margin: 0.2rem 0 0 0.2rem;
        padding: 0.1rem;
        border: 1px solid #B83B5E;
        border-radius: 8px;
        background: rgba(184, 59, 94, 0.2);
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #B83B5E;
      }

      .showNum {
        padding: 0.2rem;
        padding-bottom: 0;
        font-size: 0.1rem;

        h3 {
          color: white;
          font-size: 0.18rem;
          margin: 0;
        }

        p {
          margin: 0;
        }

        .showNum-info {
          width: 100%;
          padding: 0.2rem 0;

          .showNum-info-left {
            min-width: 1.15rem;
            justify-content: space-around;
            border-radius: 0.1rem;

            p {
              line-height: 0.32rem;
              font-size: 0.48rem;
              font-weight: 600;
            }

            span {
              white-space: nowrap;
              font-size: 0.12rem;
            }
          }

          .showNum-info-right {
            margin-left: 0.2rem;
            width: 4.7rem;
            overflow-x: auto;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            height: 1.28rem;

            @media(max-width:1024px) {
              margin-left: 0;
            }

            flex-wrap: wrap;
            font-size:0.14rem;
            justify-content: space-between;

            div {
              text-align: center;
              width: 1.15rem;
              line-height: 0.56rem;
              background: rgba(192, 211, 255, 0.3);
              min-width: 72px;
              border-radius: 0.1rem;
              margin-right: 0.1rem;
            }

            .chooseP {
              background: rgba(192, 211, 255, 0.6);
            }
          }

          .showNum-info-right::-webkit-scrollbar {
            height: 2px;
          }
        }
      }
    }

    .paramRange {
      width: 2.5rem;
      height: 0.68rem;
      position: absolute;
      left: -2.74rem;
      bottom: 0.24rem;
      border-radius: 0.06rem;
      overflow: hidden;

      img {
        height: 100%;
      }
    }

    .wind {
      width: 120px;
      height: 120px;
      position: absolute;
      left: -1.84rem;
      top: 0.24rem;
      background: url(../../../assets/img/windB.png);
      background-size: cover;

      img {
        height: 40%;
        width: 20px;
        position: absolute;
        top: 30%;
        left: 50px;
      }
    }
  }
}

.sitDetail::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.sitDetail {
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
}

.params::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.params {
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
}
</style>
